import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot } from 'firebase/firestore/lite';

import CommentData from '../types/commentData';

const commentConverter: FirestoreDataConverter<CommentData> = {
  toFirestore(comment: CommentData): DocumentData {
    return comment;
  },

  fromFirestore(docSnap: QueryDocumentSnapshot): CommentData {
    return {
      ...docSnap.data(),
      id: docSnap.id,
      created: docSnap.data().created.toDate(),
    } as CommentData;
  },
};

export default commentConverter;
